import { atom, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';
import ReferredPublicProfile, {
  andTagAtom,
} from '../../../components/WebCard/ReferredPublicProfile';

export const actionAtom = atom<string | null>(null);

export default function ReferredToWebCardPage() {
  const { id } = useParams();

  const setAndTag = useSetAtom(andTagAtom);
  if (!id) {
    return <LoadingOverlay />;
  }
  setAndTag(id);

  return (
    <Suspense fallback={<LoadingOverlay />}>
      <ReferredPublicProfile andTag={id} modalMode="fullscreen" />
    </Suspense>
  );
}
